import { create } from 'zustand';

/**
 * Si el menú lateral está abierto **en un teléfono**.
 *
 * 🔴 Por qué hace falta un store para esto: el botón que abre el menú vive en la
 * barra de arriba (`navbar.tsx`) y el menú es su **hermano** en el layout, no su
 * hijo. Sin un estado compartido habría que subir la bandera a `AppLayout` y
 * pasarla por props a los dos — que es lo mismo, pero acoplando al layout algo
 * que no le importa.
 *
 * En pantalla grande esto no se usa: ahí el menú siempre está visible y lo que
 * decide su ancho es el `collapsed` interno del propio menú, que es otra cosa
 * —angosto o ancho, pero presente— y vive donde ya vivía.
 *
 * No se persiste a propósito. Un cajón que queda abierto de la sesión anterior
 * tapa la pantalla al entrar y no se entiende por qué.
 */
interface SidebarState {
  abierto: boolean;
  abrir: () => void;
  cerrar: () => void;
  alternar: () => void;
}

export const useSidebarStore = create<SidebarState>((set) => ({
  abierto: false,
  abrir: () => set({ abierto: true }),
  cerrar: () => set({ abierto: false }),
  alternar: () => set((s) => ({ abierto: !s.abierto })),
}));

export default useSidebarStore;
